export const ADD_CART = "ADD_CART";
export const EDIT_QTY_CART = "EDIT_QTY_CART";
export const DELETE_CART = "DELETE_CART";
export const COUPON = "COUPON";
export const CLEAR_CART = "CLEAR_CART";
